import { IBacnetDevice, StartupState } from "./types";

export function getStateColor(theme: any, props: IBacnetDevice): string {

    if (props.noConnection)
        return theme.colors.negative;

    if (props.startupState === StartupState.Error)
        return theme.colors.negative;

    if (props.startupState === StartupState.Offline)
        return theme.colors.primary500;

    const startingUp = isStartingUpState(props);
    if (startingUp)
        return theme.colors.warning;
        
    return theme.colors.positive;
}

export function isStartingUpState(props: IBacnetDevice) {
    return props.startupState === StartupState.Initialized
        || props.startupState === StartupState.ReadObjectList
        || props.startupState === StartupState.ReadPropertiesOnce
        || props.startupState === StartupState.SubscribeCov
        || props.startupState === StartupState.SubscribeCovProperties;
}